const actions = {
  async getGameImage({}, image) {
    try {
      const game = await this._vm.$gameApi.get("/image", { params: image });
      return game.data;
    } catch (error) {
      console.log("GAME IMAGE error", error);
    }
  },

  async saveGameToDb({}, payload) {
    try {
      const game = await this._vm.$gameApi.post("/admin/games", payload);
      console.log("SAVE GAME", game);
      return game.data;
    } catch (error) {
      console.log("SAVE GAME error", error);
    }
  },
  async removeGameToDb({}, payload) {
    try {
      const game = await this._vm.$gameApi.delete("/admin/games", {
        data: payload,
      });
      console.log("SAVE GAME", game);
      return game.data;
    } catch (error) {
      console.log("SAVE GAME error", error);
    }
  },
  async getAdminGames({ commit }, payload) {
    try {
      commit("setAdminGames", []);
      const selectedPage = payload.selectedPage;
      const game = await this._vm.$gameApi.get("/admin/games", {
        params: {
          page: selectedPage || 1,
          selectedProvider: payload.selectedProvider || "Slotegator",
        },
      });
      console.log("game", game);

      commit("setAdminGames", game.data);
    } catch (error) {
      console.log("this error", error);
    }
  },

  async getGames({ commit }, payload) {
    try {
      const limit = payload && (payload.limit || 24);
      const search = payload && payload.search ? payload.search : null;
      const providers = payload && payload.providers ? payload.providers : [];
      const offset = payload && payload.offset;
      const filterTypes = payload && payload.filterTypes && payload.filterTypes;
      const isMobile = payload.isMobile;
      const game = await this._vm.$gameApi.get("/games", {
        params: {
          filterTypes,
          search,
          providers,
          limit,
          offset,
          isMobile,
          type: payload.type,
        },
      });
      return game.data;
    } catch (error) {
      console.log("this error", error);
    }
  },

  async getFavoriteGames({ commit }, payload) {
    try {
      const limit = payload && (payload.limit || 24);
      const search = payload && payload.search ? payload.search : null;
      const providers = payload && payload.providers ? payload.providers : [];
      const offset = payload && payload.offset;
      const filterTypes = payload && payload.filterTypes && payload.filterTypes;
      const isMobile = payload.isMobile;
      const game = await this._vm.$gameApi.get("/games/favorites", {
        params: {
          filterTypes,
          search,
          providers,
          limit,
          offset,
          isMobile,
          type: payload.type,
        },
      });
      return game.data;
    } catch (error) {
      console.log("this error", error);
    }
  },

  async getRecentGames({ commit }, payload) {
    try {
      const limit = payload && (payload.limit || 24);
      const search = payload && payload.search ? payload.search : null;
      const providers = payload && payload.providers ? payload.providers : [];
      const offset = payload && payload.offset;
      const filterTypes = payload && payload.filterTypes && payload.filterTypes;
      const isMobile = payload.isMobile;
      const game = await this._vm.$gameApi.get("/games/recent-games", {
        params: {
          filterTypes,
          search,
          providers,
          limit,
          offset,
          isMobile,
          type: payload.type,
        },
      });
      return game.data;
    } catch (error) {
      console.log("this error", error);
    }
  },

  async getLobby({}, payload) {
    try {
      const gameLobby = await this._vm.$gameApi.get("/games/lobby", {
        params: payload,
      });
      return gameLobby.data && gameLobby.data.data && (gameLobby.data.data.lobby || []);
    } catch (er) {
      console.log("get lobby", er);
    }
  },
  async initGameFlipmaster({}) {
    try {
      const gameInit = await this._vm.$gameApi.post("/flipmaster/init");
      if (gameInit.data && gameInit.data.success) return gameInit.data;
      return {
        success: false,
        message: gameInit.data && gameInit.data.message,
        redirect: gameInit.data && gameInit.data.message && !!gameInit.data.message.includes("400"),
      };
    } catch (err) {
      console.log("ERROR", err);
    }
  },
  async gameInit({}, payload) {
    try {
      const gameInit = await this._vm.$gameApi.post("/games/init", {
        params: payload,
      });
      if (gameInit.data && gameInit.data.success) return gameInit.data;
      return {
        success: false,
        message: gameInit.data && gameInit.data.message,
        redirect: gameInit.data && gameInit.data.message && !!gameInit.data.message.includes("400"),
      };
    } catch (err) {}
  },

  async gameInitDemo({}, payload) {
    try {
      const gameInit = await this._vm.$gameApi.post("/games/init-demo", {
        params: payload,
      });
      if (gameInit.data && gameInit.data.success) return gameInit.data;
      return {
        success: false,
        redirect: gameInit.data && gameInit.data.message && !!gameInit.data.message.includes("400"),
      };
    } catch (err) {
      console.log("game init error ", err);
    }
  },

  async getGameByName({}, payload) {
    try {
      const game = await this._vm.$gameApi.post("/games/getByName", payload);
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async notifyBalance({}, payload) {
    try {
      const game = await this._vm.$gameApi.post("/balance/notify", payload);
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      console.log("notifyBalance error ", err);
    }
  },
  async selfValidate() {
    try {
      const game = await this._vm.$gameApi.post("/self-validate");
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      return err;
    }
  },
  async getFirstGame({}, payload) {
    try {
      let type = payload.type;
      if (!type) type = "real-live";
      const game = await this._vm.$gameApi.post(`/games/first`, {
        type,
      });
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
    return null;
  },
  async getGameById({}, payload) {
    try {
      if (!payload.id) return null;
      const game = await this._vm.$gameApi.post(`/games/${payload.id}`);
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
    return null;
  },
  async getTestGameById({}, payload) {
    try {
      if (!payload.id) return null;
      const game = await this._vm.$gameApi.post(`/games/test/${payload.id}`);
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
    return null;
  },

  async getGamesSaved({}, payload) {
    try {
      const game = await this._vm.$gameApi.post(`/admin/games/get`, payload);
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async getGameDetailsSaved({}, payload) {
    try {
      const game = await this._vm.$gameApi.post(`/admin/game-details/get`, payload);
      if (game.data && game.data.success) return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async getGameDetails({}, payload) {
    try {
      const game = await this._vm.$gameApi.get(`/admin/game-details`, {
        params: payload,
      });
      return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async saveGameDetails({}, payload) {
    try {
      const game = await this._vm.$gameApi.post(`/admin/game-details`, payload);
      return game;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async searchGameDetail({}, payload) {
    try {
      const game = await this._vm.$gameApi.post(`/admin/search/game-details`, null, { params: payload });
      return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async filterGames({}, payload) {
    try {
      const game = await this._vm.$gameApi.post(`/admin/filter/game-details`, null, { params: payload });
      return game.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async filterGameTypes({}, payload) {
    try {
      const type = await this._vm.$gameApi.get(`/admin/types`, payload);
      return type.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async filterProviders({}, payload) {
    try {
      const type = await this._vm.$gameApi.post(`/providers`, payload);
      return type.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async saveProviderOrder({}, payload) {
    try {
      const type = await this._vm.$gameApi.post(`/admin/provider/order`, payload);
      return type.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async adminFilterProviders({}, payload) {
    try {
      const type = await this._vm.$gameApi.get(`/admin/providers`, payload);
      return type.data.data;
    } catch (err) {
      console.log("getGameByName error ", err);
    }
  },

  async filterGameTypesByProvider({}, payload) {
    try {
      const type = await this._vm.$gameApi.post(`/admin/provider/types`, payload);
      return type.data.data;
    } catch (err) {
      console.log(err);
    }
  },

  async filterProvidersByGameType({}, payload) {
    try {
      const type = await this._vm.$gameApi.post(`/admin/game-type/providers`, payload);
      return type.data.data;
    } catch (err) {
      console.log(err);
    }
  },

  async sortGames({}, payload) {
    try {
      const game = await this._vm.$gameApi.put("/admin/games/sort", payload);
    } catch (err) {
      console.log(err);
    }
  },

  async playerInit({}, payload) {
    try {
      const response = await this._vm.$gameApi.post("/player/init", payload);
      return response.data;
    } catch (err) {
      console.log(err);
      return { success: false, err };
    }
  },
  async checkMaintenance({}) {
    try {
      const response = await this._vm.$gameApi.post("/casino/maintenance/check");
      return response.data;
    } catch (err) {
      return { isMaintenance: false };
    }
  },
};

export default actions;
